import React, { Component } from "react";
import sanityClient from "./client.js";
import BlockContent from "@sanity/block-content-to-react";
import imageUrlBuilder from "@sanity/image-url";
import { CommonUtil } from '../utils/CommonUtil';
import MetaTags from 'react-meta-tags';

const builder = imageUrlBuilder(sanityClient);

class OnePost extends Component {
  constructor(props) {
    super(props);
    this.state = {
      postData: {}
    }
    this.translateLang = CommonUtil.lang;
    this.serializers = {
      types: {
        mainImage: (props) => (
          <div className="blog-detail-image">
              <img src={this.urlFor(props.node).url()} alt="" />
          </div>
        ),
      },
    };
  }
  componentDidMount() {    
    this.fetchBlog();
  }
  componentDidUpdate(prevProps) {
    if(this.translateLang !== CommonUtil.lang) {
      this.translateLang = CommonUtil.lang;
      this.fetchBlog();      
    }
  }
  urlFor(source) {
    return builder.image(source);
  }
  fetchBlog() {
    let lang = CommonUtil.lang.split("-")[0];
    const slug = this.props.match.params.slug;
    sanityClient.fetch(
      `*[slug.current == $slug]{
        "title": title["${lang}"],
        slug,
        publishedAt,
        _updatedAt,
        mainImage{
          asset->{
            _id,
            url
            }
          },
        "body": body["${lang}"],
        authors[]{
            author->{
                image,
                name,
                slug
            }
        }
      }`,
      { slug }
    ).then((data) => {
      this.setState(c => {
        c.postData = data[0];
        return c;
      })
    }).catch(console.error);
  }
  render() {
    let postData = this.state.postData;
    if (!postData) return <div>Loading...</div>;
    // set blog author
    let author = (postData.authors && postData.authors.length > 0) ? postData.authors[0].author : {};
    // setting blog date
    let date = "";
    if (postData.publishedAt) {
      date = new Date(postData.publishedAt);
      date = date.toLocaleString('default', { dateStyle: 'short' });                      
    }
    let updatedDate = "";
    if (postData._updatedAt) {
      updatedDate = new Date(postData._updatedAt);
      updatedDate = updatedDate.toLocaleString('default', { dateStyle: 'short' });                      
    }
    return (
      <div>
        <MetaTags>
          <title>{postData.title + " | Blur.live"}</title>
          <meta name="og:title" content={postData.title + " | Blur.live"} />
          <meta name="og:type" content="article" />
          <meta name="og:url" content={"https://blur.live/blog/" + (postData.slug ? postData.slug.current : "")} />
          {/* <meta name="article:author" content={author} /> NOTE: must point to a valid URL */}
          <meta name="article:publisher" content="Blur.live" />
          <meta name="og:site_name" content="Blur.live Blog" />
        </MetaTags>
        <div >
        <h1 className="ui header one-post-title">{postData.title}</h1>
          <div className="one-post-info">
            {(author) ? (
              <a href={author.slug && author.slug.current ? "/blog/author/" + author.slug.current : ""} className="one-post-writer-info">
                <div className="write-info-pic">
                  {author.image ? 
                    (<img src={this.urlFor(author.image).width(40).url()} alt={author.name} />
                  ) : ("")}
                </div>
                {(author.name) ? (
                  <div className="write-info-name">
                    <span>{author.name}</span>
                  </div>
                ) : ("")}
              </a>
            ) : ("")}
            <div className="one-post-date">{date} {date.localeCompare(updatedDate) !== 0 ? (<span>(updated on:&nbsp;{updatedDate})</span>) : ""}</div>
          </div>
        </div>
        <div className="blog-main-img">
            <img src={this.urlFor(postData.mainImage).url()} alt="" />
        </div>
        <div className="blog-contant">
          <BlockContent
            blocks={postData.body}
            projectId={sanityClient.config().projectId}
            dataset={sanityClient.config().dataset}
            serializers={this.serializers}
          />
        </div>
      </div>
    );    
  }
}
export default OnePost
